import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

export const FeatureFlaggedAlertUiOptionsSchema = z.object({
  featureFlag: z
    .string()
    .describe(
      'The platform feature flag that controls whether the alert is shown.',
    ),
  text: z.string().describe('The main alert text to display.'),
  secondaryText: z
    .string()
    .optional()
    .describe('Additional explanatory text shown below the main message.'),
  severity: z
    .enum(['error', 'warning', 'info', 'success'])
    .optional()
    .describe('The MUI alert severity variant.'),
  linkText: z
    .string()
    .optional()
    .describe('Optional label for an alert action link.'),
  linkUrl: z
    .string()
    .optional()
    .describe('Optional target URL for the alert action link.'),
});

export type FeatureFlaggedAlertUiOptions = z.infer<
  typeof FeatureFlaggedAlertUiOptionsSchema
>;

export const FeatureFlaggedAlertFieldSchema = makeFieldSchemaFromZod(
  z
    .string()
    .optional()
    .describe('Dummy field for displaying a feature-flagged alert banner'),
  FeatureFlaggedAlertUiOptionsSchema,
);

export type FeatureFlaggedAlertFieldProps =
  typeof FeatureFlaggedAlertFieldSchema.type;

export const FeatureFlaggedAlertSchema = FeatureFlaggedAlertFieldSchema.schema;
